import React, { ReactElement } from "react"
import Button from "./Button"
import { useTranslation } from "react-i18next"
import Text from "./Text"
import TransactionSummary, {
  TransactionSummaryData,
} from "./TransactionSummary"
import { Box } from "@mui/material"

interface Props {
  onConfirm: () => void
  transactionSummary: TransactionSummaryData
}

function ReviewDeposit({ onConfirm, transactionSummary }: Props): ReactElement {
  const { t } = useTranslation()

  return (
    <Box>
      <Text mb={3}>{t("Please confirm the transaction in your wallet.")}</Text>
      <TransactionSummary data={transactionSummary} />
      <Box mt={3}>
        <Button onClick={onConfirm} fullWidth>
          {t("Confirm")}
        </Button>
      </Box>
    </Box>
  )
}

export default ReviewDeposit
